import React, { useState, useContext, useEffect, useRef } from 'react';
import logoVima from '../../../../../src/assets/images/logoVima.png';
import { useHistory } from 'react-router-dom';
import useAuthCompanyService from '../../../../app/services/intranet_company/hooks/useAuthCompanyService';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import { ServiceResponse } from '../../../../app/services/shared/interfaces';
import { CompanyUser, defaultCompanyUser } from '../../../../app/models/User';
import CompanyUserForm from './forms/CompanyUserForm';
import useCommuneService from '../../../../app/services/hooks/useCommuneService';
import useRegionService from '../../../../app/services/hooks/useRegionService';
import useCountryService from '../../../../app/services/hooks/useCountryService';
import { Commune } from '../../../../app/models/Commune';
import { toast } from 'react-toastify';
import { Region } from '../../../../app/models/Region';
import { Country } from '../../../../app/models/Country';
import Wrapper from '../../../../components/default/Wrapper';
import CompanyForm from './forms/CompanyForm';
import { defaultCompany } from '../../../../app/models/Company';

const RegisterCompany: React.FC = () => {
    const history = useHistory();
    const { registerCompanyUser } = useAuthCompanyService(); // Servicio para registrar la empresa
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();
    const [errorMessage, setErrorMessage] = useState<string>('');

    const [companyUserData, setCompanyUserData] = useState<CompanyUser>(defaultCompanyUser);
    const [companyData, setCompanyData] = useState<any>(defaultCompany);
    const { getCommunesByRegion, fetchingGetCommunesByRegion } = useCommuneService();
    const { getRegionsByCountry, fetchingGetRegionsByCountry } = useRegionService();
    const { getCountries, fetchingGetCountries } = useCountryService();
    const regionIdSelected = useRef<number | undefined>(undefined);
    const countryIdSelected = useRef<number | undefined>(undefined);
    const [communes, setCommunes] = useState<Commune[]>([]);
    const [errorFields, setErrorFields] = useState<any>();
    const [regions, setRegions] = useState<Region[]>([]);
    const [countries, setCountries] = useState<Country[]>([]);
    const [step, setStep] = useState<number>(1);
    const storeCompanyUser = () => {
        companyUserData.company = companyData;
        // Llamada al servicio de registro
        registerCompanyUser(companyUserData, {
            onSuccess: (response: ServiceResponse) => {
                alert('Usuario registrado correctamente');
                history.push('/company/login');
            },
            onError: (response: ServiceResponse) => {
                setErrorMessage(response.message);
            },
            onFieldError: (response: ServiceResponse) => {
                setErrors(response.data);
            }
        });
    };

    useEffect(() => {
        getCountries({
            onSuccess: (response: ServiceResponse) => {
                setCountries(response.data.countries);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        });
    }, []);

    useEffect(() => {
        if (companyData.region_id && companyData.region_id != regionIdSelected.current) {
            getCommunesByRegion(companyData.region_id, {
                onSuccess: (response: ServiceResponse) => {
                    regionIdSelected.current = companyData.region_id ?? 0;

                    setCommunes(response.data.communes);
                    companyData.company.commune_id = 0;
                    setCompanyData(companyData);

                    setErrorFields({
                        ...errorFields,
                        region_id: '',
                        commune_id: ''
                    });
                },
                onError: (response: ServiceResponse) => {
                    toast.error(response.message);
                    companyData.region_id = Number(regionIdSelected.current);
                    setCompanyData(companyData);
                }
            });
        }
    }, [companyData.region_id]);

    useEffect(() => {
        if (companyData.country_id && companyData.country_id != countryIdSelected.current) {
            getRegionsByCountry(companyData.country_id, {
                onSuccess: (response: ServiceResponse) => {
                    countryIdSelected.current = companyData.country_id ?? 0;

                    setRegions(response.data.regions);
                    companyData.region_id = 0;
                    setCompanyData(companyData);
                    setErrorFields({
                        ...errorFields,
                        region_id: '',
                        country_id: ''
                    });
                },
                onError: (response: ServiceResponse) => {
                    toast.error(response.message);
                    companyData.country_id = Number(countryIdSelected.current);
                    setCompanyData(companyData);
                }
            });
        }
    }, [companyData.country_id]);

    const nextStep = () => {
        setStep(step + 1);
    };

    const prevStep = () => {
        setStep(step - 1);
    };

    return (
        <Wrapper>
            <div className="vh-100 d-flex bg-primary px-md-2">
                <div className="m-auto px-5 w-100" style={{ maxWidth: '600px' }}>
                    <div className="card">
                        {step == 1 ? (
                            <>
                                <h5 className="card-header bg-transparent border-bottom text-center">
                                    Información del Usuario
                                </h5>
                                <div className="card-body">
                                    <CompanyUserForm
                                        companyUserForm={companyUserData}
                                        setCompanyUserForm={setCompanyUserData}
                                        errorFields={errorMessage}
                                        communes={communes}
                                        countries={countries}
                                        regions={regions}
                                        setCommunes={setCommunes}
                                        setRegions={setRegions}
                                    />
                                </div>
                            </>
                        ) : (
                            <>
                                <h5 className="card-header bg-transparent border-bottom text-center">
                                    Información de la Empresa
                                </h5>
                                <div className="card-body">
                                    <CompanyForm
                                        companyForm={companyData}
                                        setCompanyForm={setCompanyData}
                                        errorFields={errorMessage}
                                        communes={communes}
                                        countries={countries}
                                        regions={regions}
                                        setCommunes={setCommunes}
                                        setRegions={setRegions}
                                        step={step}
                                    />
                                </div>
                            </>
                        )}
                        <div className="card-footer bg-transparent border-top  justify-content-between">
                            <div className="mb-2 row">
                                <div className="col-md-6 d-grid gap-2 mt-2">
                                    {step != 1 && (
                                        <button
                                            className="btn btn-primary rounded-pill"
                                            type="button"
                                            onClick={prevStep}
                                        >
                                            Volver
                                        </button>
                                    )}
                                </div>
                                <div className="col-md-6 d-grid gap-2 mt-2">
                                    {step == 3 ? (
                                        <button
                                            className="btn btn-primary rounded-pill"
                                            type="button"
                                            onClick={storeCompanyUser}
                                        >
                                            Crear Cuenta
                                        </button>
                                    ) : (
                                        <button
                                            className="btn btn-primary rounded-pill"
                                            type="button"
                                            onClick={nextStep}
                                        >
                                            Siguiente
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Wrapper>
    );
};

export default RegisterCompany;
